<template>
  <div class="page_1">
    <div class="title_">
      {{ list.riskType == 1 ? "主险" : "附险" }}
      <div class="cutoff_"></div>
    </div>
    <div>
      <a-row class="item_risk">
        <a-col class="flex_" :span="24">
          <a-icon
            style="color: red; margin: 0 10px"
            @click="deleteOne()"
            type="minus"
          />
          <!-- 险别基础信息 start-->
          <div class="risk_ipt_" v-if="list.edit">
            <a-input v-model="list.name" placeholder="主险名称"></a-input>
            <a-input
              @blur="handleEditOrNot(false)"
              v-model="list.code"
              placeholder="险别代码"
            ></a-input>
          </div>
          <span class="risk_name_" v-else @click="handleEditOrNot(true)">{{
            list.name
          }}</span>
        </a-col>

        <!-- 险别基础信息 end-->

        <!-- 保费 start-->
        <a-col class="marg20" :span="24">
          <template v-for="(tag, index) in list.premiumTags">
            <a-tooltip v-if="tag.length > 20" :key="tag + 't'" :title="tag">
              <a-tag
                :key="tag + 't'"
                closable
                @close="() => handleClose(tag, index)"
              >
                {{ `${tag.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag
              v-else
              :key="tag + 't'"
              closable
              @close="() => handleClose(tag, index)"
            >
              {{ tag }}
            </a-tag>
          </template>
          <a-input
            v-if="inputVisible"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
          />
          <a-tag
            v-else
            style="background: #fff; borderstyle: dashed"
            @click="showInput"
          >
            <a-icon type="plus" /> 保额
          </a-tag>
          <a-tag
            @click="handleConfig()"
            style="background: #fff; borderstyle: dashed; margin: 0 10px"
          >
            <a-icon type="plus" />
            配置工程报价
          </a-tag>
        </a-col>
        <!-- 保费 end-->

        <a-col>
          <!-- 工程报价table列表 start-->
          <div v-if="list.GCTable" style="margin: 20px 0">
            <a-button
              style="margin-bottom: 20px"
              class="editable-add-btn"
              @click="handleAdd"
            >
              新增一行
            </a-button>
            <!-- :scroll="{ x: 2000 }" -->
            <div style="width: 100%; overflow-x: scroll">
              <a-table
                style="min-width: 2000px"
                bordered
                :pagination="false"
                :data-source="dataSource"
                :columns="columns"
              >
                <template slot="GCwide" slot-scope="text, record">
                  <editable-cell
                    :wideObj="record.wideObj"
                    @change="onCellChange(record.key, 'GCwide', $event)"
                  />
                </template>
                <template
                  v-for="col in cols"
                  :slot="col"
                  slot-scope="text, record, index"
                >
                  <div :key="col">
                    <a-input
                      v-if="record.editable"
                      style="margin: -5px 0; min-width: 100px"
                      :value="text"
                      @change="
                        (e) =>
                          handleChange(
                            e.target.value,
                            record.key,
                            col,
                            record,
                            list
                          )
                      "
                      @blur="(e) => handelBlur(e.target.value, col, record)"
                    />
                    <template v-else>
                      <div class="col_" @click="handleItemClick(record)">
                        {{ text }}
                      </div>
                    </template>
                  </div>
                </template>
                <template slot="operation" slot-scope="text, record">
                  <a-popconfirm
                    v-if="dataSource.length"
                    title="确定删除?"
                    @confirm="() => onDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </div>
          </div>
          <!-- 工程报价table列表 end-->
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import EditableCell from "./EditableCell.vue";
import common from "./common";
import option from "./option";

export default {
  components: {
    EditableCell,
  },
  props: {
    list: {
      type: Object,
      default: {},
    },
    mainRiskList:{
      type: Array,
      default:[]
    },
    listIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      inputVisible: false,
      inputValue: "",
      count: 4, //每行数据的key
      delCount: null, //要删除的列数据下标
      // cols: [], //可编辑列表 //不默认展示数据
      premium: this.list.premium, //处理数据是需要
      cols: this.list.cols, //默认展示数据
      dataSource: this.list.tableData, //默认展示数据
      columns: this.list.columns, //默认展示数据
    };
  },
  mounted() {
    console.log(this.list, "子组件中--->list");
  },
  methods: {
    ...common,
    handleSubmit() {},
    handleEditOrNot(editV) {
      console.log(this.mainRiskList,"--mainRiskList",this.list)
      let count = 0
      this.mainRiskList.map(item=>{
        if(item.code == this.list.code){
          count++
        }
      })
      if(count>1){
        this.$notification.warning({message:'险别代码重复,已重置'})
        this.list.code = "RISK_" + this.listIndex
      }
      let mainRiskList = this.list;
      mainRiskList.edit = editV;
      this.emitData(mainRiskList);
    },
    deleteOne() {
      this.$emit("delete", this.listIndex);
    },
    handleClose(removedTag, index) {
      this.delCount = index;
      console.log(this.delCount, "要删除的列数据下标");
      let mainRiskList = this.list;
      console.log("del-->", removedTag, mainRiskList);
      const premiumTags = mainRiskList.premiumTags.filter(
        (tag) => tag !== removedTag
      );
      this.list.premiumTags = [...premiumTags];
      // this.emitData(mainRiskList);
      this.renderDataSource();
      this.handleConfig();
    },
    emitData(list) {
      // console.log("emit", JSON.stringify(list));
      let data = {
        listIndex: this.listIndex,
        list: list,
      };
      this.$emit("change", data);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        // this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      let mainRiskList = this.list;
      let numRex = /^\d+$/;
      if (!this.inputValue) {
        this.$notification.warning({message: `请输入`});
        return;
      }
      if (!numRex.test(this.inputValue)) {
        this.$notification.warning({message: `请输入数字`});
        this.inputValue = "";
        return;
      }
      console.log(this.inputValue, "--->", numRex.test(this.inputValue));
      const inputValue = this.inputValue;
      let premiumTags = mainRiskList.premiumTags;
      if (inputValue && premiumTags.indexOf(inputValue) === -1) {
        premiumTags = [...premiumTags, inputValue];
      }
      mainRiskList.premiumTags = premiumTags;
      console.log(premiumTags, mainRiskList);
      Object.assign(this, {
        premiumTags,
        inputVisible: false,
        inputValue: "",
      });
      // this.emitData(mainRiskList);
      this.handleConfig();
    },
    //配置工程报价按钮
    handleConfig() {
      this.addColumns();
      console.log(this.list.premiumTags, "保费列表");
      let mainRiskList = this.list;
      mainRiskList.GCTable = true;
      this.setFatherTable();
      // this.emitData(mainRiskList);
    },
    addColumns() {
      //确定保额列
      let columns = [];
      let premium = [];
      this.cols = [];
      columns.push({
        title: "工程造价",
        dataIndex: "GCwide",
        width: 450,
        // fixed: "left",
        scopedSlots: { customRender: "GCwide" },
      });
      this.list.premiumTags.map((item, index) => {
        columns.push({
          title: item,
          dataIndex: "coverage" + index,
          scopedSlots: { customRender: "coverage" + index },
        });
        premium.push({
          key: "coverage" + index,
          value: item,
        });
        this.cols.push("coverage" + index);
      });
      columns.push({
        title: "操作",
        dataIndex: "operation",
        width: 80,
        // fixed: "right",
        scopedSlots: { customRender: "operation" },
      });
      this.premium = [...premium];
      this.columns = [...columns];
    },
    //配置工程报价按钮end

    //编辑保费列
    handleChange(value, key, col, record, item) {
      console.log(value, key, col, record, item, "---->table改变");
      record[col] = value;
      this.dataSource = [...this.dataSource];
      this.setFatherTable();
    },
    renderDataSource() {
      //重新渲染数据
      let delIndex = this.delCount;
      let data = [...this.dataSource];
      let arr = this.cols;
      let key = "coverage";
      data.map((item, idx) => {
        for (let i = parseInt(delIndex + 1); i < arr.length; i++) {
          // console.log(i,idx)
          // console.log(key+i,item[key+i])
          if (item[key + i]) {
            item[key + (i - 1)] = item[key + i];
          }
        }
        delete item[key + (arr.length - 1)];
      });
      this.dataSource = [...data];
    },
    handelBlur(value, col, record) {
      var re_quantity_float = /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/; //正小数
      if (!re_quantity_float.test(value)) {
        record[col] = "";
        this.$notification.warning({message: `请输入正值小数`});
      }
      this.dataSource = [...this.dataSource];
    },
    setFatherTable() {
      //把table数据传到父页,单向传递，子向父传递，请求时用，初始化不用
      let mainRiskList = this.list;
      mainRiskList.tableData = this.dataSource;
      mainRiskList.columns = this.columns;
      mainRiskList.cols = this.cols;
      mainRiskList.premium = this.premium;
      console.log(mainRiskList,"---->mainRiskList子组件")
      this.emitData(mainRiskList);
    },
    handleItemClick(record) {
      console.log("cilck", record);
      record.editable = true;
      this.dataSource = [...this.dataSource];
    },
    //编辑保费列

    //工程造价列表
    onCellChange(key, dataIndex, wideObj) {
      console.log(key, dataIndex, wideObj, "===onCellChange");
      const result = this.formatWideObj(wideObj);
      const dataSource = [...this.dataSource];
      const target = dataSource.find((item) => item.key === key);
      if (target) {
        target[dataIndex] = result;
        target["wideObj"] = wideObj; //自定义值
        this.dataSource = dataSource;
      }
      console.log(dataSource, this.dataSource, "编辑后");
      this.setFatherTable();
    },

    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter((item) => item.key !== key);
      this.setFatherTable();
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        GCwide: "100万(不含)-1000万(含)",
        wideObj: {
          maxAmount: 10000000,
          maxIsContain: "1",
          minAmount: 1000000,
          minIsContain: "0",
        },
      };
      console.log(count, dataSource);
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.page_1 {
  min-height: 300px;
  .col_ {
    width: 100%;
    height: 20px;
  }

  .item_risk {
    // display: flex;
    margin-bottom: 10px;
    // align-items: center;
    .risk_ipt_ {
      display: flex;
      input {
        margin: 0 10px;
      }
    }
    .risk_name_ {
      min-width: 20px;
    }
  }
}

.flex_ {
  display: flex;
  align-items: center;
}
.marg20 {
  margin: 20px 0;
}
.title_ {
  margin: 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  .cutoff_ {
    // width:90%;
    flex: 1;
    height: 5px;
    background: #f0f0f0;
  }
}
</style>
